export const DATA = {
  games: [
    {
      id: 0,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846789/juegoThiago_cbk0iu_pafqll.webp',
      alt: 'Un juego alternativo',
      name: 'Treevia',
      description: 'Testea tu conocimiento de arboles.',
      link: 'https://thiagojuarezsibello.github.io/Treevia/'
    },
    {
      id: 1,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846789/juegoAgus_mosgec_vywkaz.webp',
      alt: 'Un juego alternativo',
      name: 'Wordle',
      description: 'Adivina la palabra escondida.',
      link: 'https://agustinesposito29.github.io/wordle.sustentabilidad.io/'
    },
    {
      id: 2,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846789/JuegoMati_myoj37_wkxsny.webp',
      alt: 'Un juego alternativo',
      name: 'EcoMatch',
      description: 'Encuentra todas las parejas de tarjetas.',
      link: 'https://matiasniedermaier.github.io/memoMatch/'
    },
    {
      id: 3,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846788/JuegoNahue_vrpy9i_vk0hwl.webp',
      alt: 'Un juego alternativo',
      name: 'Piedra Papel Tijeras',
      description: 'Juega el clásico de piedra papel y tijeras.',
      link: 'https://nahuelberensztein.github.io/juegoddw/'
    }
  ],
  navBins: [
    {
      id: 0,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1717967273/red-bin_p3asrm.svg',
      alt: 'Tacho rojo',
      width: '40',
      color: 'Red'
    },
    {
      id: 1,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1717967272/gray-bin_irnmko.svg',
      alt: 'Tacho gris',
      width: '40',
      color: 'Gray'
    },
    {
      id: 2,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1717967271/blue-bin_s8xhdc.svg',
      alt: 'Tacho azul',
      width: '40',
      color: 'Blue'
    },
    {
      id: 3,
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1717967272/green-bin_gfkdtt.svg',
      alt: 'Tacho verde',
      width: '40',
      color: 'Green'
    }
  ],
  trash: [
    {
      id: 0,
      name: 'Banana',
      targetBin: 'Green',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846788/banana_dm3svm_iykduz.webp',
      alt: 'banana'
    },
    {
      id: 1,
      name: 'Cesped',
      targetBin: 'Green',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846790/magazine_shszak_t91guc.webp',
      alt: 'cesped'
    },
    {
      id: 2,
      name: 'Apple',
      targetBin: 'Green',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846814/rotten-apple_oqckiy_gdxww9.webp',
      alt: 'manzana-comida'
    },
    {
      id: 3,
      name: 'Saquito de te',
      targetBin: 'Green',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846818/teabag_ytalje_bd7clk.webp',
      alt: 'Saquito de te'
    },
    {
      id: 4,
      name: 'Serrucho',
      targetBin: 'Blue',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846817/saw_fkbxsf_bdob4o.webp',
      alt: 'Serrucho'
    },
    {
      id: 5,
      name: 'Taza de plastico',
      targetBin: 'Blue',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846823/teacup_mupdsc_wabkkq.webp',
      alt: 'Vaso de plastico'
    },
    {
      id: 6,
      name: 'Tornillo',
      targetBin: 'Blue',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846787/bolt_qzgn3k_ug9kc5.webp',
      alt: 'Tornillo'
    },
    {
      id: 7,
      name: 'Botella de plastico',
      targetBin: 'Blue',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846825/water-bottle_c3eu89_sccqe3.webp',
      alt: 'Botella de plastico'
    },
    {
      id: 8,
      name: 'Termometro',
      targetBin: 'Red',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846822/thermometer_pleexr_ev6vzh.webp',
      alt: 'Termometro'
    },
    {
      id: 9,
      name: 'Bateria',
      targetBin: 'Red',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846786/battery_ri5jse_hucdde.webp',
      alt: 'Pila alcalina'
    },
    {
      id: 10,
      name: 'Desechos toxicos',
      targetBin: 'Red',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846795/nuclear_htmxnw_igdabn.webp',
      alt: 'Desechos tóxicos'
    },
    {
      id: 11,
      name: 'Jeringa',
      targetBin: 'Red',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846823/vaccine_tiltgi_dik2hm.webp',
      alt: 'Jeringa'
    },
    {
      id: 12,
      name: 'Papel-higienico',
      targetBin: 'Gray',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846823/toilet-roll_zzb8kd_ld1byn.webp',
      alt: 'Papel higienico'
    },
    {
      id: 13,
      name: 'Caja de carton',
      targetBin: 'Gray',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846796/open-box_odsgiq_b0nlrl.webp',
      alt: 'Caja de carton'
    },
    {
      id: 14,
      name: 'Periodico',
      targetBin: 'Gray',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846796/newspaper_axixye_jfn0nu.webp',
      alt: 'Periodico'
    },
    {
      id: 15,
      name: 'Revista',
      targetBin: 'Gray',
      src: 'https://res.cloudinary.com/djwg0bdyh/image/upload/v1718846790/magazine_shszak_t91guc.webp',
      alt: 'Revista'
    }
  ]
};
